import { DateTimeHelper } from './';
import { AppScriptLoader } from './app.script-loader';

export class AppUtils {
    static DateTime: DateTimeHelper = new DateTimeHelper();
    static AppScriptLoader: AppScriptLoader = AppScriptLoader.Instance;
}
